import Cookies from "js-cookie";
import { Commit } from "vuex";

// Define the state structure

// Initial state
const state: appState = {
  sidebar: {
    opened: Cookies.get("sidebarStatus")
      ? !!+Cookies.get("sidebarStatus")
      : true,
    withoutAnimation: false,
  },
  device: "desktop",
};

// Define mutations with proper types
const mutations = {
  TOGGLE_SIDEBAR(state: appState) {
    state.sidebar.opened = !state.sidebar.opened;
    state.sidebar.withoutAnimation = false;
    if (state.sidebar.opened) {
      Cookies.set("sidebarStatus", "1");
    } else {
      Cookies.set("sidebarStatus", "0");
    }
  },
  CLOSE_SIDEBAR(state: appState, withoutAnimation: boolean) {
    Cookies.set("sidebarStatus", "0");
    state.sidebar.opened = false;
    state.sidebar.withoutAnimation = withoutAnimation;
  },
  TOGGLE_DEVICE(state: appState, device: string) {
    state.device = device;
  },
};

// Define actions with proper types
const actions = {
  toggleSideBar({ commit }: { commit: Commit }) {
    commit("TOGGLE_SIDEBAR");
  },
  closeSideBar(
    { commit }: { commit: Commit },
    { withoutAnimation }: { withoutAnimation: boolean }
  ) {
    commit("CLOSE_SIDEBAR", withoutAnimation);
  },
  toggleDevice({ commit }: { commit: Commit }, device: string) {
    commit("TOGGLE_DEVICE", device);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
